export const getPermissionsFromGroupOwner = (groupOwner: any, group_number: number) => {
	const permission = (groupOwner as any).permissions.filter(
		(permission: any) => permission.group_number === group_number
	);

	const permissions =
		permission && permission.length > 0 ? permission[0]?.permission_and_subscription.permissions : null;

	return permissions;
};

export const filterByFirstTrue = (main: any, source: any): any => {
	if (typeof main !== typeof source) return {};

	// if main is boolean
	if (typeof main === "boolean") {
		return main === true ? source : {};
	}

	// if objects
	if (typeof main === "object" && main !== null && source !== null) {
		// 🚨 if this object has a view=false → kill whole branch
		if ("view" in main && main.view === false) {
			return {};
		}

		const result: any = {};
		for (const key of Object.keys(main)) {
			if (key in source) {
				const filtered = filterByFirstTrue(main[key], source[key]);
				if (Object.keys(filtered).length > 0 || filtered === true || filtered === false) {
					result[key] = filtered;
				}
			}
		}
		return result;
	}

	return {};
};
